import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2954d62c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " sổ cân đối hàng tồn kho ", -1))
const _hoisted_2 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_3 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_5 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_6 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, PropType } from "vue";
import {
  IKhoResponseBase,
  ISoCanDoiVatTuTotalsResponseBase,
  IVatTuHangTonKhoItemV2ResponseBase,
} from "@/core/interfaces/ApiResponses";
import {
  getPdfPrintContentStyle,
  PDF_BAO_CAO_MARGINS,
} from "@/components/shared/pdf-viewer/pdf-content.config";
import HangTonKhoTable from "../table-components/HangTonKhoTable.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import SignatureCol from "@/layout/_shared/SignatureCol.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'HangTonKhoPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  from: { type: Date, default: () => new Date() },
  to: { type: Date, default: () => new Date() },
  items: {
    type: Array as PropType<IVatTuHangTonKhoItemV2ResponseBase[]>,
    required: true,
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  rowStartIndex: {
    type: Number,
    default: 0,
  },
  totals: {
    type: Object as PropType<ISoCanDoiVatTuTotalsResponseBase | null>,
    default: null,
  },
},
  setup(__props) {

const paperStyle = getPdfPrintContentStyle({
  orientation: "landscape",
  margins: PDF_BAO_CAO_MARGINS,
});

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);

const dateTime = computed(() => {
  const { from, to } = props;
  return `Từ ${from.getMonth() + 1} năm ${from.getFullYear()} đến tháng ${
    to.getMonth() + 1
  } năm ${to.getFullYear()}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "printing-paper",
    style: _normalizeStyle(_unref(paperStyle))
  }, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createVNode(DivRow, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 3 }),
        _createVNode(DivCol, { cols: 6 }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("p", _hoisted_2, _toDisplayString(dateTime.value), 1),
            _createElementVNode("p", _hoisted_3, " Kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
          ]),
          _: 1
        }),
        _createVNode(DivCol, { cols: 3 })
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(DivRow, { class: "row mt-2" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 12 }, {
          default: _withCtx(() => [
            _createVNode(HangTonKhoTable, {
              "is-print-modal": true,
              items: __props.items,
              "row-start-index": __props.rowStartIndex,
              stripe: false,
              totals: __props.totals
            }, null, 8, ["items", "row-start-index", "totals"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
      ])
    ])
  ], 4))
}
}

})